import { AfterViewInit, ComponentFactoryResolver, Directive, ElementRef, EventEmitter, Injector, Input, NgZone, ViewContainerRef } from '@angular/core';
import { DynamicLinkComponent } from '@shared/components/dynamic-link/dynamic-link.component';

@Directive({
    selector: '[appReplaceWordWithLink]',
    standalone: false
})
export class ReplaceWordWithLinkDirective implements AfterViewInit {
  @Input() wordToReplace!: string;
  @Input() linkPath!: string;
  @Input() onClickEvent = new EventEmitter<void>();
  @Input() redirect = new EventEmitter<void>();

  constructor(
    private el: ElementRef,
    private readonly vcRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private ngZone: NgZone) { }

  ngAfterViewInit(): void {
    // Necesario puesto que si se realizan cambios Angular necesita detectarlos
    this.ngZone.run(() => {
      setTimeout(() => this.replaceContent())
    })
  }

  replaceContent() {
    const content = this.el.nativeElement.textContent;
    if (!content.includes(this.wordToReplace)) return;

    const parts = content.split(this.wordToReplace);

    this.el.nativeElement.textContent = '';

    if (parts[0]) {
      const textNode = document.createTextNode(parts[0]);
      this.el.nativeElement.appendChild(textNode);
    }

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DynamicLinkComponent);
    const componentRef = this.vcRef.createComponent(
      componentFactory,
      0,
      this.injector
    );

    componentRef.instance.path = this.linkPath;
    componentRef.instance.text = `"${this.wordToReplace}"`;
    componentRef.instance.redirect = this.redirect;

    this.el.nativeElement.appendChild(componentRef.location.nativeElement);

    if (parts[1]) {
      const textNode = document.createTextNode(parts[1]);
      this.el.nativeElement.appendChild(textNode);
    }
  }
}
